export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\"/><circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"#21A67A\"/><path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M7.136 11a.498.498 0 01-.325-.12L5.175 9.475l.651-.76 1.21 1.039 3.05-4.533.829.558-3.364 5a.503.503 0 01-.415.221z\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  }
};